import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { DATE_SEPARATOR } from '../constants/dateTime';
export var getCalendarDay = function getCalendarDay(date) {
  if (date instanceof Date) {
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  }
  var _date$split = date.split(DATE_SEPARATOR),
    _date$split2 = _slicedToArray(_date$split, 3),
    year = _date$split2[0],
    month = _date$split2[1],
    day = _date$split2[2];
  return {
    year: Number(year),
    month: Number(month),
    day: Number(day)
  };
};